import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'
import i18n from '@/VueI18n'

export class NotOccurredFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super(
			i18n.t('fireRiskDashboardReactionNegative') as string,
			'material-symbols:thumb-down-rounded',
			FireOutbreakReactionEnum.NEGATIVE,
		)
	}
}
